var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPlay(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38,
    height: 36,
    viewBox: "0 0 38 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11 7H27C32.5 7 35.5 11 36.4 17L37.4 24.5C37.9 28.5 35 30.5 32.6 29.2C31 28.4 29.6 26.4 28 24C27.2 22.8 26.4 22.4 25 22.4H13C11.6 22.4 10.8 22.8 10 24C8.4 26.4 7 28.4 5.4 29.2C3 30.5 0.1 28.5 0.6 24.5L1.6 17C2.5 11 5.5 7 11 7ZM9.5 10.5V13H7V16H9.5V18.5H12.5V16H15V13H12.5V10.5H9.5ZM27.2 12C27.2 13.105 28.095 14 29.2 14C30.305 14 31.2 13.105 31.2 12C31.2 10.895 30.305 10 29.2 10C28.095 10 27.2 10.895 27.2 12ZM23.2 16C23.2 17.105 24.095 18 25.2 18C26.305 18 27.2 17.105 27.2 16C27.2 14.895 26.305 14 25.2 14C24.095 14 23.2 14.895 23.2 16Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlay);
export default __webpack_public_path__ + "static/media/play.4d520e2aeb47057d1bffaef330bb0a9e.svg";
export { ForwardRef as ReactComponent };